<div>
  <form [formGroup]="inputForm" enctype="multipart/form-data">
    <div class="flex flex-col sm:flex-row gap-2">
      <div class="flex-1 min-w-0">
        <div class="block text-[13px] font-medium !text-slate-600 mb-1">
          {{ "URL" | transloco }}
        </div>
        <div class="relative">
          <span
            class="absolute left-3 flex items-center !text-slate-400 pointer-events-none"
            style="top: 0; bottom: 0"
          >
            <igntr-icon name="externalLink" [size]="14"></igntr-icon>
          </span>
          <input
            id="url"
            formControlName="url"
            type="text"
            [ngClass]="
              inputForm.get('url').errors
                ? '!border-red-400'
                : '!border-slate-200'
            "
            class="w-full pl-9 pr-3 h-9 rounded-lg bg-slate-50/50 focus:bg-white border focus:!border-[var(--primary-color)] text-[14px] !text-slate-800 outline-none transition-colors"
            placeholder="https://…"
            autocomplete="off"
          />
        </div>
      </div>
      <div class="flex-1 min-w-0">
        <div class="block text-[13px] font-medium !text-slate-600 mb-1">
          {{ "text" | transloco }}
        </div>
        <input
          id="text"
          formControlName="text"
          type="text"
          [ngClass]="
            inputForm.get('text').errors
              ? '!border-red-400'
              : '!border-slate-200'
          "
          class="w-full px-3 h-9 rounded-lg bg-slate-50/50 focus:bg-white border focus:!border-[var(--primary-color)] text-[14px] !text-slate-800 outline-none transition-colors"
          placeholder="{{ 'text' | transloco }}"
          autocomplete="off"
        />
      </div>
      <div class="shrink-0 flex flex-col">
        <span
          class="text-[13px] font-medium mb-1 opacity-0 select-none"
          aria-hidden="true"
          >{{ "add" | transloco }}</span
        >
        <button
          type="button"
          (click)="addLink()"
          class="text-[14px] bg-[var(--primary-color)] px-3.5 h-9 rounded-lg text-white font-medium inline-flex items-center justify-center gap-1.5"
        >
          <igntr-icon name="plus"></igntr-icon>{{ "add" | transloco }}
        </button>
      </div>
    </div>
  </form>

  @if (links?.controls?.length) {
    <div class="mt-3 flex flex-col gap-1.5">
      @for (link of links?.controls; track link; let i = $index) {
        <div
          class="group flex items-center gap-3 px-3 py-2 rounded-lg bg-white border !border-slate-200/70 hover:!border-slate-300 transition-colors"
        >
          <span
            class="shrink-0 w-8 h-8 rounded-lg bg-slate-100 !text-slate-500 inline-flex items-center justify-center"
          >
            <igntr-icon name="externalLink" [size]="15"></igntr-icon>
          </span>
          <div class="min-w-0 flex-1">
            <div class="text-[13px] font-medium !text-slate-800 truncate">
              {{ link.value.text }}
            </div>
            <div class="text-[12px] !text-slate-400 truncate">
              {{ link.value.url }}
            </div>
          </div>
          <button
            type="button"
            (click)="deleteLink(i)"
            [title]="'delete' | transloco"
            class="shrink-0 p-1.5 rounded-md !text-slate-400 hover:!text-red-600 hover:bg-red-50 opacity-100 lg:opacity-0 group-hover:opacity-100 transition-all inline-flex"
          >
            <igntr-icon name="trash"></igntr-icon>
          </button>
        </div>
      }
    </div>
  }
</div>
